<template>
  <aside class="fixed-bar">
    <button class="btn-custom-service" @click.prevent="openCSRWidget">
      <i class="mc-support"></i>
    </button>
    <button class="btn-go-top" @click.prevent="() => goTop()">
      <i class="mc-arrow-circle-up"></i>
    </button>
  </aside>
</template>

<script>
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import useGoAnchor from '../../composables/useGoAnchor'
import useCSR from '../../composables/useCSR'

export default defineComponent({
  name: 'FixedBar',
  props: {
    name: {
      type: String,
      default: 'FixedBar'
    }
  },
  setup() {
    const store = useStore()
    const isMobile = computed(() => store.state.isMobile)

    const { goTop } = useGoAnchor()
    const { openCSRWidget } = useCSR()

    return {
      isMobile,

      goTop,
      openCSRWidget
    }
  }
})
</script>
